import React from "react";

const TableListApis = ({ items, rowNumber }) => {
  return (
    <div className="table__api__container">
      <table className="table__api">
        <tr className="iransans-b table__api__head">
          <th rowSpan={4} className="table__api__one">
            {rowNumber}
          </th>
          <th>کد API</th>
          <th>زیر سیستم ها</th>
          <th>موجودیت ها</th>
          <th>فرم ها</th>
          <th>عملکرد</th>
        </tr>
        <tr className="iransans-b">
          <td>{items.id}</td>
          <td>{items.apiSubsystems}</td>
          <td>{items.apiEntities}</td>
          <td>{items.apiForms}</td>
          <td rowSpan={4}>{items.function}</td>
        </tr>
        <tr className="iransans-b table__api__head">
          <th>عنوان API ها</th>
          <th>ورژن</th>
          <th>پارامترهای ورودی</th>
          <th>پارامترهای خروجی</th>
        </tr>
        <tr className="iransans-b">
          <td>{items.title}</td>
          <td>{items.version}</td>
          <td>{items.inlet}</td>
          <td>{items.outlet}</td>
        </tr>
      </table>
    </div>
  );
};

export default TableListApis;
